<section class="content-layout h-full">
  <mat-drawer-container [hasBackdrop]="false">
    <mat-drawer
      #matDrawer
      [mode]="'over'"
      [opened]="false"
      [position]="'end'"
      [disableClose]="true"
      (closed)="onDrawerClosed()"
    >
      <router-outlet></router-outlet>
    </mat-drawer>
    <mat-drawer-content>
      <div class="task-template">
        <!-- Header -->
        <header class="task-template__header px-10 py-8">
          <!-- Title & Breadcrumb -->
          <div class="title">
            <div class="breadcrumb mb-1">
              <span class="path">
                <a [routerLink]="['../']">Layouts</a>
                <span class="separator">/</span>
                {{ projectTemplate?.related_to_type }}
                <span class="separator">/</span>
                {{ projectTemplate?.name }}
                <span class="separator">/</span>
                Versions
              </span>
            </div>
            <h1 class="m-0">{{ projectTemplate?.name }} Versions</h1>
          </div>

          <div class="main-actions"></div>
        </header>

        <main class="task-template__main">
          <ng-container *ngIf="projectTemplateVersionsCount > 0; else noTemplates">
            <table
              mat-table
              matSort
              [matSortActive]="'id'"
              [matSortDisableClear]="true"
              [matSortDirection]="'asc'"
              [dataSource]="dataSource"
              [trackBy]="trackByFn"
            >
              <!-- Name -->
              <ng-container matColumnDef="id">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Id</th>
                <td mat-cell *matCellDef="let projectTemplateVersion">
                  <div class="name-content">{{ projectTemplateVersion.id }}</div>
                </td>
              </ng-container>

              <!-- Created -->
              <ng-container matColumnDef="event">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Event</th>
                <td mat-cell *matCellDef="let projectTemplateVersion">
                  {{ projectTemplateVersion.event }}
                </td>
              </ng-container>

              <!-- Last Updated -->
              <ng-container matColumnDef="user">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Updated By</th>
                <td mat-cell *matCellDef="let projectTemplateVersion">
                  {{ projectTemplateVersion?.user?.name }}
                </td>
              </ng-container>

              <!-- Last Updated -->
              <ng-container matColumnDef="created_at">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Updated At</th>
                <td mat-cell *matCellDef="let projectTemplateVersion">
                  {{ projectTemplateVersion.created_at | date: 'MMM dd, y' }}
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let projectTemplateVersion">
                  <div class="flex">
                    <button
                      mat-icon-button
                      class="delete-task"
                      [matTooltip]="'Restore This Version'"
                      (click)="restoreVersion(projectTemplateVersion.id)"
                    >
                      <mat-icon [svgIcon]="'restore'"></mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="projectTemplateVersionsTableColumns; sticky: true"></tr>

              <tr
                class="template-row"
                mat-row
                *matRowDef="let projectTemplateVersion; columns: projectTemplateVersionsTableColumns"
              ></tr>
            </table>
          </ng-container>
          <ng-template #noTemplates>
            <div class="no-templates">There are no templates!</div>
          </ng-template>
        </main>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</section>
